import { makeStyles, createStyles } from '../../styles';
export default makeStyles((theme) => createStyles({
    indeterminate: {},
    icon: {
        color: theme.checkbox.foreground,
        '$round &': {
            color: '#fff',
        },
        '&$indeterminate': {
            color: theme.checkbox.background,
            width: '100%',
            height: '100%',
        },
    },
}));
//# sourceMappingURL=CheckboxIcon.styles.js.map